import React from 'react';
import './footerLanding.css'

import { Layout } from 'antd';
const { Footer } = Layout;

const FooterLanding = () => {
    return <Footer
        style={{
            textAlign: 'center',
            backgroundColor: '#3E246B',
            color: 'white'
        }}
    >
        Mentoring ©{new Date().getFullYear()} | Todos los derechos reservados. | v3.6.1
    </Footer>
}

export default FooterLanding;